export type UploadedCustomerMessageFile = {
  fileId: string;
  fileName: string;
  fileType: string;
  fileUrl: string;
  shouldConvertToPdf: boolean;
};
